import { Card, Title3 } from '@fluentui/react-components';
import type { OfferLine } from '../../../models/Offer';
import { CurrencyDisplay } from '../../common/CurrencyDisplay';
import { calculateOfferTotals } from '../../../utils/tax';

export const OfferSummary = ({ lines, taxRate }: { lines: OfferLine[]; taxRate: number }) => {
  const totals = calculateOfferTotals(lines, taxRate);
  return (
    <Card>
      <Title3>Summary</Title3>
      <p>Subtotal USD: {totals.subtotalUsd.toFixed(2)}</p>
      <CurrencyDisplay usdAmount={totals.subtotalUsd} tndAmount={totals.subtotalTnd} />
      <p>Tax TND: {totals.taxAmountTnd.toFixed(3)}</p>
      <p><strong>Total TND: {totals.totalTnd.toFixed(3)}</strong></p>
    </Card>
  );
};
